/**
 * SEO AB 分桶：id hash 后对 100 取模，保证 50% / 25% / 25%。
 * 0–49 对照；50–74 SEO 标题；75–99 SEO 摘要。
 */
const SEO_AB_BUCKET_SIZE = 100;

const hashIdToSeoAbValue = (text) => {
    let hash = 0;
    const str = String(text);

    for (let i = 0; i < str.length; i++) {
        hash = (Math.imul(hash, 31) + str.charCodeAt(i)) >>> 0;
    }

    return hash % SEO_AB_BUCKET_SIZE;
};

const normalizeSeoAbNum = (seoAbValue) => {
    if (seoAbValue === null || seoAbValue === undefined || seoAbValue === '') {
        return NaN;
    }

    return Number(seoAbValue);
};

const isSeoAbTitleBucket = (seoAbValue) => {
    const n = normalizeSeoAbNum(seoAbValue);

    return Number.isFinite(n) && n >= 50 && n <= 74;
};

const isSeoAbSummaryBucket = (seoAbValue) => {
    const n = normalizeSeoAbNum(seoAbValue);

    return Number.isFinite(n) && n >= 75 && n <= 99;
};

const parseDateTime = (value) => {
    if (!value || typeof value !== 'string') {
        return NaN;
    }

    const matched = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/);

    if (!matched) {
        return NaN;
    }

    const [, year, month, day, hour, minute, second] = matched;

    return new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour),
        Number(minute),
        Number(second),
    ).getTime();
};

const normalizeSeoTimeSwitch = (seoTimeSwitch) => {
    if (Array.isArray(seoTimeSwitch)) {
        return seoTimeSwitch[0] || null;
    }

    return seoTimeSwitch || null;
};

const getSeoAbSearchPaths = (seoTimeSwitch) => {
    const timeSwitch = normalizeSeoTimeSwitch(seoTimeSwitch);
    const channelList = timeSwitch && timeSwitch.channelList;

    if (!Array.isArray(channelList)) {
        return [];
    }

    return channelList.map((item) => item && item.id).filter(Boolean);
};

const isSeoAbSearchPath = (searchPath, searchPaths = []) => {
    if (!searchPaths.length) {
        return false;
    }

    return String(searchPath || '')
        .split(',')
        .some((path) => searchPaths.some((prefix) => path.indexOf(prefix) === 0));
};

/**
 * 试验栏目与时间窗均来自 seoTimeSwitch，用 id 生成 0-99 的固定值（50/25/25 分桶）。
 * 不在栏目或时间窗外时返回 null。
 */
const getSeoAbFixedValue = ({ searchPath, seoTimeSwitch, id, createTime } = {}) => {
    const timeSwitch = normalizeSeoTimeSwitch(seoTimeSwitch);
    const searchPaths = getSeoAbSearchPaths(timeSwitch);

    if (!isSeoAbSearchPath(searchPath, searchPaths)) {
        return null;
    }

    const startTime = parseDateTime(timeSwitch && timeSwitch.startTime);
    const endTime = parseDateTime(timeSwitch && timeSwitch.endTime);
    const now = parseDateTime(createTime);

    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || !Number.isFinite(now) || now < startTime || now > endTime) {
        return null;
    }

    if (id === undefined || id === null || id === '') {
        return null;
    }

    return hashIdToSeoAbValue(id);
};

/**
 * 将 SEO AB 分桶结果写入 seoData / docData，供模板和前端使用。
 */
const applySeoAbExperiment = ({ seoData = {}, docData = {}, seoTimeSwitch, id, searchPath, createTime } = {}) => {
    if (!seoData.docTitle) {
        seoData.docTitle = docData.title || '';
    }

    const seoAbValue = getSeoAbFixedValue({
        searchPath: searchPath || docData.searchPath,
        seoTimeSwitch,
        id: id !== undefined && id !== null && id !== '' ? id : docData.id,
        createTime: createTime || docData.createTime,
    });

    seoData.seoAbValue = seoAbValue;
    docData.seoAbValue = seoAbValue;
    docData.seoTitle = seoData.title || '';
    docData.seoDescription = seoData.description || '';

    return seoAbValue;
};

module.exports = {
    SEO_AB_BUCKET_SIZE,
    hashIdToSeoAbValue,
    isSeoAbTitleBucket,
    isSeoAbSummaryBucket,
    getSeoAbFixedValue,
    applySeoAbExperiment,
};
